import React from 'react';
import MenuButton from '../../../../dropdown/default/menuButton/MenuButton';
import MenuItem from '../../../../dropdown/default/menuItem/MenuItem';
import Menu from '../../../../dropdown/default/menu/Menu';

const OptionsDropdown = ({
  onDeleteClick = () => {},
  onOpenEditWithIaClick = () => {},
  isWithIaOptions = false,
}) => {
  return (
    <Menu menuButton={<MenuButton />}>
      <MenuItem onClick={onDeleteClick}>Eliminar</MenuItem>
      {isWithIaOptions && <MenuItem onClick={onOpenEditWithIaClick}>Editar con IA</MenuItem>}
    </Menu>
  );
};

export default OptionsDropdown;
